module.exports = __webpack_public_path__ + "static/media/progman_15.05aed55a.ico";